import React, { useContext } from 'react'
import { Flex, ToggleButton } from '@leverege/ui-elements'
import { DataContext } from '@visx/xychart'

export default function ChartTypeSelector( props ) {
  const { onChange, value, small = false } = props
  const { margin } = useContext( DataContext )

  let style

  if ( margin ) {
    style = {
      position : 'absolute',
      top : 20,
      right : margin.right
    }
  }

  return (
    <Flex
      direction="row"
      align="center"
      style={style}>
      <ToggleButton
        variant={`radioSelector${small ? 'Small' : ''}First`}
        eventData="count"
        value={value === 'count'}
        onChange={onChange}>
        Count
      </ToggleButton>
      <ToggleButton
        variant={`radioSelector${small ? 'Small' : ''}Last`}
        eventData="average"
        value={value === 'average'}
        onChange={onChange}>
        Average
      </ToggleButton>
    </Flex>
  )
}
